import React from 'react';
import './App.css';
import DashBoard from './pages/dashBoard';
import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';
import SignUp from './pages/signUp';
import { AuthContextProvider } from './contextApis/authContext';
import LoginComponent from './components/loginComponents';
import Documentation from './pages/documentation';
import SlackRedirectComp from './components/slackRedirectComp';
import Forgetpassword from './pages/ForgotPassword';
import NotFoundPage from './pages/notFoundPage';
import { initializeApp } from "firebase/app";
import TwoFactorPage from './pages/twoFactorAunthentication';
import VsCodeSignIn from './pages/vsCodeSignIn';
import VsCodeVerifyEmail from './pages/vsCodeVerifyEmail';
import VsCodeSignUp from './pages/vsCodeSignUp';
import VsCodeDashboard from './pages/vsCodeDashboard';
import VsCodeResetPassword from './pages/vsCodeResetPassword';
import { VsCodeAuthContextProvider } from './contextApis/vsCodeAuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PricingPage from './pages/pricingPage';
import VSCodeOnboarding from './pages/vsCodeOnboarding';
import PaymentRedirect from './pages/paymentRedirect';
import PaymentCancelled from './pages/paymentCancelled';
import NewTeams from './pages/newTeams';
import InviteMembers from './pages/inviteMembers';
import PAYGDashboard from './pages/paygDashboard';
import SubscriptionSuccess from './pages/subscriptionSuccess';
import BuyCredits from './pages/buyCredits';
import PrivacyPolicy from './pages/privacyPolicy';
import TermsOfService from './pages/termsOfService';
import styled, { createGlobalStyle } from 'styled-components';

// Global styles to ensure dark background across the entire app
const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  }
  
  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    min-height: 100vh;
    background: #0a0a0f;
  }
  
  #root {
    min-height: 100vh;
    background: #0a0a0f;
  }
`;



function App() 
{
  
  return (
    <>
      <GlobalStyle />
      <GoogleOAuthProvider clientId="836806459453-3i2964pmqiqhtlnp70uq4l0d5ld6ou6o.apps.googleusercontent.com">
      <Router>
        <AuthContextProvider>
        <VsCodeAuthContextProvider>
        <Routes>
          <Route path="/" element={<VsCodeSignIn/>}/>
          <Route path="/dashboard/*" element={<VsCodeDashboard/>} />
          <Route path="/signup" element={<VsCodeSignUp/>}/>
          <Route path="/login" element={<VsCodeSignIn/>}/>
         
          
          <Route path="/slack/redirect" element={<SlackRedirectComp/>}/>
          <Route path="/forget-password" element={<Forgetpassword/>}/>
          <Route path="/vscode/signup" element={<VsCodeSignUp/>}/>
          <Route path="/vscode/signin" element={<VsCodeSignIn/>}/>
          <Route path="/vscode/verify-email" element={<VsCodeVerifyEmail/>}/>
          <Route path="/vscode/dashboard" element={<VsCodeDashboard/>}/>
          <Route path="/vscode/reset-password" element={<VsCodeResetPassword/>}/>
          <Route path="/vscode/onboarding" element={<VSCodeOnboarding/>}/>
          <Route path="/payment-redirect" element={<PaymentRedirect/>}/>
          <Route path="/payment-cancelled" element={<PaymentCancelled/>}/>
          <Route path="/pricing" element={<PricingPage/>}/>
          <Route path="/new_teams" element={<NewTeams/>}/>
          <Route path="/invite_members" element={<InviteMembers/>}/>
          <Route path="/payg-dashboard" element={<PAYGDashboard/>}/>
          <Route path="/subscription/success" element={<SubscriptionSuccess/>}/>
          <Route path="/buy-credits" element={<BuyCredits/>}/>
          <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          <Route path="/terms" element={<TermsOfService/>}/>
          <Route path="*" element={<NotFoundPage/>}/>

          
        </Routes>
        </VsCodeAuthContextProvider>
        </AuthContextProvider>
      </Router>
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
